import { getFeature } from 'Cloud/Application/FeaturesEs6';

export const showEditPdfButtonForAttach: boolean = getFeature('show-edit-pdf-button-attach');
